(() => {
  const start = () => {
    const isIt = (document.documentElement.lang || '').toLowerCase().startsWith('it');
    const route = ((window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || (isIt ? '/it/' : '/')).replace(/\/?$/, '/');
    const exampleUrl = route + 'pages/booking-sprint-example' + (isIt ? '#italiano' : '#english');
    const translationData = document.getElementById('LsgInteractionTranslations');
    const translations = translationData ? JSON.parse(translationData.textContent) : {};
    const exampleLabel = translations.example_link || (isIt ? 'Guarda un esempio di cosa ricevi' : 'See an example of what you receive');
    const syncProductExample = () => {
      document.querySelectorAll('[data-testid="product-information-details"]').forEach(details => {
        details.dataset.lsgProductLayout = 'ready';
        const title = details.querySelector('h1');
        const header = title && title.closest('.group-block');
        const content = header && header.querySelector(':scope > .group-block-content');
        if (!content) return;
        header.classList.add('lsg-product-summary');
        const source = details.querySelector('a[href*="/pages/booking-sprint-example"]:not([data-lsg-example-near-price])');
        if (!source) return;
        let link = details.querySelector('[data-lsg-example-near-price]');
        if (!link) link = document.createElement('a');
        link.removeAttribute('id');
        link.removeAttribute('style');
        link.className = 'lsg-example-link';
        link.dataset.lsgExampleNearPrice = 'true';
        link.href = exampleUrl;
        link.textContent = exampleLabel;
        content.appendChild(link);
      });
    };
    const localizeInternalLinks = () => {
      if (route === '/') return;
      const language = (document.documentElement.lang || '').toLowerCase();
      document.querySelectorAll('#MainContent a[href], .lsg-site-header a[href], .lsg-site-footer a[href]').forEach(link => {
        const targetLanguage = (link.getAttribute('hreflang') || link.getAttribute('lang') || '').toLowerCase();
        if (link.hasAttribute('download') || (targetLanguage && targetLanguage !== language)) return;
        const raw = link.getAttribute('href');
        if (!raw || raw.startsWith('#')) return;
        let url;
        try { url = new URL(raw, window.location.href); } catch { return; }
        if (url.origin !== window.location.origin || !/^https?:$/.test(url.protocol)) return;
        if (!/^\/(?:pages|products|blogs|collections|policies|cart|search)(?:\/|$)/.test(url.pathname) && url.pathname !== '/') return;
        if (url.hash === '#english') return;
        link.setAttribute('href', route + url.pathname.replace(/^\//, '') + url.search + url.hash);
      });
    };
    localizeInternalLinks();
    document.addEventListener('shopify:section:load', localizeInternalLinks);
    window.addEventListener('pageshow', localizeInternalLinks);
    syncProductExample();
    if (!document.documentElement.dataset.lsgProductLayoutBound) {
      document.documentElement.dataset.lsgProductLayoutBound = 'true';
      document.addEventListener('shopify:section:load', syncProductExample);
      window.addEventListener('pageshow', syncProductExample);
    }
    const root = document.querySelector('.lsg');
    if (!root || root.dataset.interactionsReady === 'true') return;
    root.dataset.interactionsReady = 'true';
    const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const getScrollContainer = () => (window.matchMedia('(min-width: 990px)').matches && document.querySelector('.page-wrapper')) || document.scrollingElement || document.documentElement;
    const header = root.querySelector('.lsg-header');
    if (header) {
      const progress = document.createElement('div');
      progress.className = 'lsg-scroll-progress';
      progress.setAttribute('aria-hidden', 'true');
      const bar = document.createElement('span');
      progress.appendChild(bar);
      header.appendChild(progress);
      let pending = false;
      const update = () => {
        const scrollContainer = getScrollContainer();
        const max = Math.max(1, scrollContainer.scrollHeight - scrollContainer.clientHeight);
        bar.style.transform = `scaleX(${Math.min(1, Math.max(0, scrollContainer.scrollTop / max))})`;
        pending = false;
      };
      window.addEventListener('scroll', () => { if (!pending) { pending = true; requestAnimationFrame(update); } }, { passive: true, capture: true });
      window.addEventListener('resize', update, { passive: true });
      update();
    }
    const bindChoice = (items, onChoose) => items.forEach((item, index) => {
      item.setAttribute('role', 'button');
      item.setAttribute('tabindex', '0');
      item.setAttribute('aria-pressed', 'false');
      item.addEventListener('click', () => onChoose(index));
      item.addEventListener('keydown', event => {
        if (event.key === 'Enter' || event.key === ' ') { event.preventDefault(); onChoose(index); }
      });
    });
    const preview = root.querySelector('.lsg-preview');
    if (preview) {
      const rows = Array.from(preview.querySelectorAll('.lsg-preview-row'));
      const hint = document.createElement('div');
      hint.className = 'lsg-interactive-hint';
      hint.textContent = isIt ? 'Tocca una voce per esplorare' : 'Tap a row to explore';
      if (rows[0]) preview.insertBefore(hint, rows[0]);
      const detail = document.createElement('div');
      detail.className = 'lsg-live-detail';
      detail.setAttribute('aria-live', 'polite');
      detail.hidden = true;
      const foot = preview.querySelector('.lsg-preview-foot');
      if (foot) preview.insertBefore(detail, foot); else preview.appendChild(detail);
      const copy = isIt ? [
        ['Posizionamento', 'Verificare se la proposta spiega il motivo di viaggio, non solo la camera.', 'Definire un’offerta per un segmento e un periodo.'],
        ['Date deboli', 'Individuare i vuoti ricorrenti dai dati della struttura.', 'Costruire un motivo di soggiorno mirato, non uno sconto generico.'],
        ['Prenotazione diretta', 'Verificare se il beneficio è visibile vicino alla richiesta di prenotazione.', 'Rendere il vantaggio concreto e coerente con le condizioni.'],
        ['Priorità', 'Capire quali iniziative sono già state eseguite.', 'Scegliere un’offerta, un periodo e un percorso da misurare.']
      ] : [
        ['Positioning', 'Check whether the offer explains the reason to travel, not just the room.', 'Define an offer for one guest segment and period.'],
        ['Quiet dates', 'Identify recurring gaps using the property’s data.', 'Build a specific reason to stay, not a generic discount.'],
        ['Direct booking', 'Check whether the benefit is visible near the booking enquiry.', 'Make the advantage concrete and consistent with the conditions.'],
        ['Priorities', 'Understand which activities have already been carried out.', 'Choose one offer, one period and one journey to measure.']
      ];
      bindChoice(rows, index => {
        const item = copy[index];
        if (!item) return;
        rows.forEach((row, i) => { row.classList.toggle('is-active', i === index); row.setAttribute('aria-pressed', String(i === index)); });
        detail.replaceChildren();
        const label = document.createElement('small'); label.textContent = isIt ? 'Esempio di analisi' : 'Illustrative analysis';
        const title = document.createElement('strong'); title.textContent = item[0];
        const paragraph = document.createElement('p'); paragraph.textContent = item[1] + ' ' + item[2];
        detail.append(label, title, paragraph); detail.hidden = false;
      });
    }
    const process = root.querySelector('.lsg-process');
    if (process) {
      const steps = Array.from(process.querySelectorAll('.lsg-step'));
      const note = document.createElement('div');
      note.className = 'lsg-step-note'; note.hidden = true; note.setAttribute('aria-live', 'polite');
      process.appendChild(note);
      const notes = isIt ? [
        'Scegli il pacchetto in base al problema. Per date precise puoi acquistare direttamente lo Sprint: l’Audit non è obbligatorio. Pagamento una tantum.',
        'Condividi struttura, date, disponibilità, tariffe, obiettivi e link. I tempi partono quando le informazioni richieste sono complete.',
        'Analizziamo posizionamento, offerta e percorso di prenotazione, con i concorrenti previsti dal pacchetto.',
        'Audit e strategia iniziale Sprint entro 5 giorni lavorativi dagli input completi; strategia iniziale Growth entro 7. La struttura implementa, con le call e le review previste.'
      ] : [
        'Choose the package that fits the problem. For specific dates, purchase the Sprint directly: the Audit is optional. One-time payment.',
        'Share the property, dates, availability, rates, objectives and links. Delivery timing begins after all required information is complete.',
        'We review positioning, the offer and the booking journey, including the competitors listed in your package.',
        'Audit and initial Sprint strategy within 5 business days after complete inputs; initial Growth strategy within 7. Your property implements, with the sessions and reviews included in your package.'
      ];
      bindChoice(steps, index => {
        steps.forEach((step, i) => { step.classList.toggle('is-active', i === index); step.setAttribute('aria-pressed', String(i === index)); });
        note.textContent = steps[index].dataset.lsgNote || notes[index] || ''; note.hidden = false;
      });
    }
    const sprintCard = root.querySelector('#support .lsg-upgrade');
    if (sprintCard && !sprintCard.querySelector('[data-lsg-demo]')) {
      const link = document.createElement('a'); link.href = exampleUrl; link.textContent = exampleLabel;
      link.className = 'lsg-example-link'; link.dataset.lsgDemo = 'true'; sprintCard.appendChild(link);
    }
    const founder = root.querySelector('.lsg-founder-copy');
    if (founder) {
      const bio = founder.querySelector('.lsg-lead');
      if (bio) bio.textContent = isIt
        ? 'Sono Vincenzo Proto. Il mio percorso unisce economia aziendale, vendite B2B ed esperienza nell’amministrazione alberghiera a Club Med St. Moritz. Con Low Season Growth porto questo approccio commerciale nelle date più tranquille della tua struttura: a chi rivolgersi, cosa proporre e quali azioni mettere in pratica.'
        : 'I’m Vincenzo Proto. My background combines business economics, B2B sales and hotel administration experience at Club Med St. Moritz. With Low Season Growth, I bring that commercial perspective to your quieter dates: who to reach, what to offer and which actions to take.';
      if (!founder.querySelector('[data-lsg-founder-profile]')) {
        const profile = document.createElement('a'); profile.href = 'https://www.linkedin.com/in/vincenzoproto';
        profile.target = '_blank'; profile.rel = 'noopener noreferrer'; profile.className = 'lsg-founder-profile';
        profile.dataset.lsgFounderProfile = 'true'; profile.textContent = isIt ? 'Il mio percorso professionale su LinkedIn' : 'My professional background on LinkedIn';
        founder.appendChild(profile);
      }
    }

    const menu = root.querySelector('.lsg-menu');
    if (menu) {
      menu.querySelectorAll('a').forEach(link => link.addEventListener('click', () => { menu.open = false; }));
      document.addEventListener('keydown', event => { if (event.key === 'Escape' && menu.open) { menu.open = false; const summary = menu.querySelector('summary'); if (summary) summary.focus(); } });
    }
    root.querySelectorAll('.lsg-card,.lsg-insight,.lsg-upgrade,.lsg-founder-copy,.lsg-faq-list').forEach(el => el.classList.add('is-visible'));
    const back = document.createElement('button'); back.type = 'button'; back.className = 'lsg-back-top'; back.textContent = '↑';
    back.setAttribute('aria-label', isIt ? 'Torna in alto' : 'Back to top'); root.appendChild(back);
    const updateBack = () => back.classList.toggle('is-visible', getScrollContainer().scrollTop > 700);
    window.addEventListener('scroll', updateBack, { passive: true, capture: true });
    window.addEventListener('resize', updateBack, { passive: true });
    back.addEventListener('click', () => getScrollContainer().scrollTo({ top: 0, behavior: reduced ? 'auto' : 'smooth' })); updateBack();
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true }); else start();
})();


